<div class="mb-4">
  <app-alerts />
</div>

<app-public-contact-form
  (submitSuccessEvent)="handleSubmitSuccessEvent($event)" />
